/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/no-output-on-prefix */

import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';
@Component({
  standalone: false,
  selector: 'ideapa-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OtpInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OtpInputComponent),
      multi: true,
    },
  ],
})
export class OtpInputComponent implements ControlValueAccessor {
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput!: NgOtpInputComponent;

  @Input()
  disabled = false;

  @Input()
  hasError = false;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  focusToFirstElementAfterValueUpdate = false;
  otpLength = 6;

  showOtpComponent = true;
  value = '';
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: this.otpLength,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    separator: '',
    showError: true,
  };

  propagateChange = (value: string) => {};
  onTouched = () => {};
  validateFn: any = () => {};

  validate(control: FormControl) {
    const res = this.validateFn(control);
    if (res) this.hasError = true;
    return res;
  }

  constructor(private cd: ChangeDetectorRef) {}

  onOtpChange(value: string) {
    this.value = value;
    this.propagateChange(this.value);
    this.onTouched();
  }

  writeValue(obj: string) {
    console.log('obj: ', obj);
    this.value = obj;
    this.cd.detectChanges();
    this.ngOtpInput.setValue(obj);
  }

  registerOnChange(fn: (value: string) => void) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.cd.detectChanges();
  }

  onBlur() {
    this.blur.emit();
  }
}
